import { apiClient } from './api';
import type { AdminUserListItem, ImpersonationUserData } from '../types/admin';

export const adminService = {
  /**
   * Search users (admin only)
   * GET /api/admin/users/?search={query}
   */
  async searchUsers(query: string): Promise<AdminUserListItem[]> {
    return apiClient.get<AdminUserListItem[]>('/api/admin/users/', { search: query });
  },

  /**
   * Get user data for impersonation (admin with frontend_tester permission only)
   * GET /api/admin/users/{id}/
   * Returns user data including their auth token, permissions, and frontend_state
   */
  async getUserForImpersonation(id: number): Promise<ImpersonationUserData> {
    return apiClient.get<ImpersonationUserData>(`/api/admin/users/${id}/`);
  },
};
